import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { PurchaseTrendRequest, PurchaseTrendResponse } from '@erp/rpc';

export function usePurchaseTrend(input: PurchaseTrendRequest, enabled = true) {
  return useQuery({
    ...orpc.rebates.purchaseTrend.get.queryOptions({ input }),
    enabled,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    select: (result: { data: PurchaseTrendResponse }) => result.data,
  });
}
